import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import {
  baseUrl,
  customHeaders,
  thriweMarketPlacePhillipinesUrl,
  thriweMarketPlaceUaeUrl,
  thriweMarketPlaceUrl,
} from '../../../../Containers/Config/index.js';
import { GET_BOOKING_LIST_V2, GET_BOOKING_LIST_V2_SUCCESS, GET_BOOKING_LIST_V2_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* getBookingListV2({ payload }) {
  let url = ['HSBC_BEACH_CLUB', 'ENBD_NATIONAL_DAY', 'MASTERCARD_FAB', 'CBD_GOLF_V2', 'VISA_PVT', 'MASTERCARD_UAE', 'MASHREQ', 'EIB_V2'].includes(
    Constant.PROJECT_CODE,
  )
    ? thriweMarketPlaceUaeUrl
    : ['HSBC_BENEFITS'].includes(Constant.PROJECT_CODE)
      ? thriweMarketPlacePhillipinesUrl
      : thriweMarketPlaceUrl;
  try {
    const response = yield call(apiCall, {
      url: `${url}/v1/admin/bookings`,
      method: 'POST',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      // yield put({
      //   type: MAIN_AREA_LOADER_HIDE,
      // })

      yield put({
        type: GET_BOOKING_LIST_V2_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_BOOKING_LIST_V2_ERROR,
        payload: response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_BOOKING_LIST_V2_ERROR, payload: error });
  }
}

export function* watchBookingListV2() {
  yield takeEvery(GET_BOOKING_LIST_V2, getBookingListV2);
}

function* bookingListV2Saga() {
  yield all([fork(watchBookingListV2)]);
}

export default bookingListV2Saga;
